import React, { createElement, Component } from 'react';
import './index.css';
import { render } from 'react-dom';
import { AppRouter } from './AppRouter';
// ── Helpers ───────────────────────────────────────────────────────────────────
function getCookie(name: string): string | null {
  const match = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
  return match ? decodeURIComponent(match[1]) : null;
}
function setCookie(name: string, value: string, maxAge: number) {
  document.cookie = `${name}=${encodeURIComponent(value)}; Max-Age=${maxAge}; Path=/; SameSite=Lax`;
}
// ── Variant assignment ────────────────────────────────────────────────────────
const isLive = window.location.hostname.endsWith('legendaryreads.com');
const isV2Path = window.location.pathname.startsWith('/v2');
const isV3Path = window.location.pathname.startsWith('/v3');
const isV4Path = window.location.pathname.startsWith('/v4');
const isV5Path = window.location.pathname.startsWith('/v5');
// Valid split-test variants for the 4-way test
const SPLIT_VARIANTS = ['V1', 'V3', 'V4', 'V5'] as const;
type SplitVariant = (typeof SPLIT_VARIANTS)[number];
function isValidSplitVariant(v: string): v is SplitVariant {
  return SPLIT_VARIANTS.includes(v as SplitVariant);
}
function assignRandomVariant(): SplitVariant {
  const r = Math.random();
  if (r < 0.25) return 'V1';
  if (r < 0.5) return 'V3';
  if (r < 0.75) return 'V4';
  return 'V5';
}
let variant: string;
let reason: string;
if (isV5Path) {
  variant = 'D_V5';
  reason = 'forced_by_path_v5';
} else if (isV4Path) {
  variant = 'D_V4';
  reason = 'forced_by_path_v4';
} else if (isV3Path) {
  variant = 'D_V3';
  reason = 'forced_by_path_v3';
} else if (isV2Path) {
  variant = 'D_V2';
  reason = 'forced_by_path_v2';
} else if (!isLive) {
  // Preview: / always shows V1
  variant = 'V1';
  reason = 'preview_forced';
} else {
  // Live + / path: 4-way split between V1, V3, V4, V5 (25% each)
  const COOKIE_NAME = 'lp_variant_4w';
  const stored = getCookie(COOKIE_NAME);
  if (stored && isValidSplitVariant(stored)) {
    variant = stored;
    reason = 'reused_cookie';
  } else {
    variant = assignRandomVariant();
    setCookie(COOKIE_NAME, variant, 604800); // 7 days
    reason = 'assigned_random';
  }
}
// Expose globally so App.tsx can read it without re-parsing cookie
;
(window as any).__abVariant = variant;
// Debug log (temporary — remove after validation)
console.log('AB variant:', variant, '| reason:', reason, '| host:', window.location.hostname, '| path:', window.location.pathname);
// ClickMagick ref mapping
// Split test variants (/ path): use HL03 suffix
// Direct access variants (/vX path): use HL01 suffix
const cmcRefMap: Record<string, string> = {
  // Split test (25% each)
  V1: 'DO.BTF.LPV1.HL03',
  V3: 'DO.BTF.LPV3.HL03',
  V4: 'DO.BTF.LPV4.HL03',
  V5: 'DO.BTF.LPV5.HL03',
  // Direct access
  D_V2: 'DO.BTF.LPV2.HL01',
  D_V3: 'DO.BTF.LPV3.HL01',
  D_V4: 'DO.BTF.LPV4.HL01',
  D_V5: 'DO.BTF.LPV5.HL01'
};
const cmcRef = cmcRefMap[variant] || 'DO.BTF.LPV1.HL03';
(window as any).clickmagick_cmc = {
  uid: '141056',
  hid: '808495452',
  cmc_project: 'TFF',
  vid_info: 'on',
  cmc_ref: cmcRef,
  log_action: '.cta'
};
(function loadClickMagick() {
  if (document.querySelector('script[data-cm="cmc"]')) return;
  const s = document.createElement('script');
  s.src = 'https://cdn.clkmc.com/cmc.js';
  s.async = false;
  s.defer = false;
  s.setAttribute('data-cm', 'cmc');
  document.head.appendChild(s);
})();
// ── Render app ────────────────────────────────────────────────────────────────
render(<AppRouter data-id="element-647" />, document.getElementById('root'));
(() => {
  if ((window as any).__meta_pixel_loaded) return;
  (window as any).__meta_pixel_loaded = true;
  const f = window as any;
  if (f.fbq) return;
  const n: any = f.fbq = function (...args: any[]) {
    n.callMethod ? n.callMethod.apply(n, args) : n.queue.push(args);
  };
  if (!f._fbq) f._fbq = n;
  n.push = n;
  n.loaded = true;
  n.version = '2.0';
  n.queue = [];
  const s = document.createElement('script');
  s.async = true;
  s.src = 'https://connect.facebook.net/en_US/fbevents.js';
  document.head.appendChild(s);
  f.fbq('init', '1847761419278798');
  f.fbq('track', 'PageView');
  f.fbq('track', 'ViewContent');
})();
(() => {
  if ((window as any).__clarity_loaded) return;
  (window as any).__clarity_loaded = true;
  const f = window as any;
  const n: any = f.clarity = function (...args: any[]) {
    n.q = n.q || [];
    n.q.push(args);
  };
  const s = document.createElement('script');
  s.async = true;
  s.src = 'https://www.clarity.ms/tag/vn5x9ewnu9';
  document.head.appendChild(s);
})();
(() => {
  if ((window as any).__cs_loaded) return;
  (window as any).__cs_loaded = true;
  const s = document.createElement('script');
  s.src = 'https://t.contentsquare.net/uxa/dc0bea528efc9.js';
  s.async = true;
  document.head.appendChild(s);
})();